export default __webpack_public_path__ + "locales/lv/FormFillingTipsDialog.json?hash=5ed0fb7bd85a4f0362f62a6247cf66a5";